import { EffortListItem } from 'types/efforts';
import { TimecardListItemData } from 'types/timecards';
import { portalAPI } from './portalAPI';
import { accumulatedQueryWithFilters } from './util/endpointBuilder';

type Common = {
    id: number;
    date: string;
    totalTimeInSeconds: number;
};

type DraftTimecardItem = Common & {
    kind: 'DRAFT_TIMECARD';
    timecard: TimecardListItemData;
};

type FinalizedTimecardItem = Common & {
    kind: 'FINALIZED_TIMECARD';
    timecard: TimecardListItemData;
};

type BdEffortItem = Common & {
    kind: 'BD_EFFORT';
    effort: EffortListItem;
};

export type TimeRecordItem = DraftTimecardItem | FinalizedTimecardItem | BdEffortItem;

const APITimeRecordsSlice = portalAPI.enhanceEndpoints({ addTagTypes: ['TimeRecords'] }).injectEndpoints({
    endpoints: (builder) => ({
        getTimeRecordsWithFilters: accumulatedQueryWithFilters<TimeRecordItem>(builder, '/v1/dashboard/time-records', {
            providesTags: ['TimeRecords'],
            // The feed is heterogeneous — a timecard and a BD effort can share a numeric id.
            dedupeKey: (item) => `${item.kind}:${item.id}`,
        }),
    }),
    overrideExisting: false,
});

export const { useLazyGetTimeRecordsWithFiltersQuery } = APITimeRecordsSlice;
